var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12"},[_c('indexHeader',{attrs:{"title":_vm.$t('employeesSalaries.salaryAddition'),"description":_vm.$t('employeesSalaries.FromHereYouCanAddNewEmployeesSalaries')}}),_c('indexTable',{attrs:{"searchText":_vm.$t('employeesSalaries.SearchForASalary'),"emptyTableText":_vm.$t('employeesSalaries.ThereAreNoPaychecks'),"emptyTableSubText":_vm.$t('allerts.TryAddingSomeItemsToTheTableAndTryAgain'),"buttonRole":_vm.$user.role.employees_salaries_add,"statusSearch":true,"statusValues":[
          { title: _vm.$t('orders.situation'), value: '' },
          { title: _vm.$t('orders.all'), value: '' },
          { title: _vm.$t('invoices.draft'), value: 0 },
          { title: _vm.$t('invoices.approved'), value: 1 }
        ],"cloumns":[
          {
            column: 'code',
            title: _vm.$t('employeesSalaries.Salary'),
            type: 'mainLink',
            sort: true
          },
          {
            column: 'employee_id',
            title: _vm.$t('employeesSalaries.functionary'),
            type: 'link',
            to: 'employee',
            sort: true,
            link: true
          },
          {
            column: 'date',
            title: _vm.$t('employeesSalaries.date'),
            type: 'text',
            sort: true
          },
          {
            column: 'description',
            title: _vm.$t('employeesSalaries.thatsAbout'),
            type: 'text',
            sort: true
          },
          {
            column: 'notes',
            title: _vm.$t('employeesSalaries.note'),
            type: 'text',
            sort: true
          },
          {
            column: 'cost',
            title: _vm.$t('employeesSalaries.cost'),
            type: 'text',
            sort: true
          },
          {
            column: 'user_name',
            title: 'اسم المسئول',
            type: 'text',
            sort: true
          },
          {
            column: 'status',
            title: _vm.$t('bills.situation'),
            type: 'status',
            sort: true,
            values: [
              { title: _vm.$t('invoices.draft'), value: 0, color: 'dark' },
              { title: _vm.$t('invoices.approved'), value: 1, color: 'success' }
            ]
          },
          {
            column: 'options',
            title: _vm.$t('employeesSalaries.Settings'),
            type: 'options',
            options: [
              { name: 'show' },
              { name: 'printEmployeesSalarie', role: true },
              {
                name: 'edit',
                role: _vm.$user.admin || _vm.$user.role.employees_salaries_edit
              },
              { name: 'file' },
              { name: 'download', role: true },
              {
                name: 'delete',
                role: _vm.$user.admin || _vm.$user.role.employees_salaries_delete
              }
            ]
          }
        ],"deleteText":{
          attention: _vm.$t('allerts.Attention'),
          areYouReallySureToDeleteTheItem: _vm.$t('allerts.areYouReallySureToDeleteTheItem'),
          close: _vm.$t('allerts.close'),
          confirm: _vm.$t('allerts.confirm'),
          loading: _vm.$t('allerts.loading')
        }}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }